export default "## 路由嵌套\n\nen_US: Nested Routes\n";